var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationFinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M63 36h-2V17.414L53.586 10H19v26h-2V8h37.414L63 16.586V36",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 63h-2v-2.838L9.051 48.316a.998.998 0 01.003-.639l3.07-9c.076-.221.227-.409.426-.531l4.93-3 1.04 1.708-4.62 2.812-2.845 8.338 3.894 11.68A1 1 0 0115 60v3",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 64h-2V51.11L23 42v-6c0-1.14-.819-2-1.906-2-1.135 0-2.094.916-2.094 2l-.01 8.142-1 7-1.98-.284.99-6.929V36c0-2.168 1.875-4 4.094-4C23.284 32 25 33.757 25 36v5.89L27 51v13",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 72h-2v-8H13v8h-2v-9a1 1 0 011-1h16a1 1 0 011 1v9",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M23 68h2v-2h-2zM67 63h-2v-3a1 1 0 01.051-.316l3.894-11.68-2.845-8.338-4.62-2.812 1.04-1.708 4.93 3c.199.122.35.31.426.531l3.07 9a.998.998 0 01.003.639L67 60.162V63",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 63h-2l.024-12.217L55 41.89V36c0-2.243 1.716-4 3.906-4C61.125 32 63 33.832 63 36v7.929l.99 6.929-1.98.284L61 44v-8c0-1.084-.959-2-2.094-2-1.087 0-1.906.86-1.906 2l-.024 6.217L55 51.11V63M55 68h2v-2h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-2v-8H53v8h-2v-8c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v8M62 18h-9V9h2v7h7v2M23 16h2v-2h-2zM27 16h2v-2h-2zM31 16h2v-2h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M21 22h38v-2H21z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M21 26h38v-2H21zM21 30h38v-2H21zM45 54h2V34h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M49 54h2V38h-2zM41 54h2V40h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M37 54h2V36h-2zM29 54h2V38h-2zM29 58h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M33 54h2V42h-2zM33 58h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M37 58h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M41 58h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M45 58h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M49 58h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationFinance;